const BORDER_WIDTH_OFFSET = 1;
export const getOffsetSpace = (size) => `${parseInt(size.replace('px', ''), 10) - BORDER_WIDTH_OFFSET}px`;
